import { Api } from 'mapistry-shared/api';
import React, { StrictMode } from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import { App } from './App';

// Uncomment to see React Query devtools
// import { ReactQueryDevtools } from 'react-query-devtools';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
Api.setApiUrl(process.env.API_URL!);

ReactDOM.render(
  <StrictMode>
    <App />
    {/* Uncomment to see React Query devtools */}
    {/* <ReactQueryDevtools initialIsOpen={false} /> */}
  </StrictMode>,
  document.getElementById('root'),
);
